<template>
  <div class="left_menu">
    <!-- <div v-bind:class="{main_nav: true, active: isMenuActive}"> -->
    <div>
      <div>
        <div id="left_hd_menu">
          <div @click="route('DcTop')">トップページ</div>
          <div @click="route('DcAbout2')" v-if="isHaseko">RASHIKUについて</div>
          <div @click="route('DcAbout')" v-else>mm/styleについて</div>
          <div @click="routeCategory()">商品を選ぶ</div>
          <!-- <div @click="route('DcConstructModel')">施工事例</div> -->
          <div @click="route('DcPaymentGuide')">ご購入ガイド</div>
          <div @click="route('DcCorpInformation')">運営会社案内</div>
          <div class="hd_menu_pickup" @click="route('DcOrderSignIn')" v-if="!isLogin">会員登録/ログイン</div>
          <div class="hd_menu_pickup" @click="route('DcMyPage')" v-else>マイページ</div>
        </div>
        <div calss="menu_bunner" @click="route('DcAbout')" v-if="!isHaseko">
          <img :src="getImage('bunner/biginner.webp')">
        </div>
        <div calss="menu_bunner" @click="route('DcSpecialPrice')" v-if="!isHaseko">
          <img :src="getImage('bunner/corp_price.webp')">
        </div>
        <div id="buy_flow">
          <div class="menu_title">ご購入までの流れ</div>
          <div class="div_flow">
            <div class="flow_content">1.設置場所のサイズを測る</div>
            <div class="flow_arrow"></div>
            <div class="flow_content">2.商品をカスタマイズする</div>
            <div class="flow_arrow"></div>
            <div class="flow_content">3.価格を確認しご注文</div>
          </div>
        </div>
        <div id="buy_flow" v-if="false">
          <div class="menu_title">ご購入までの流れ</div>
          <div>
            <div>空間のサイズを測る</div>
            <div>商品を選ぶ</div>
            <div>寸法を入力する</div>
            <div>カラーを選ぶ</div>
            <div>納品先を入力する</div>
            <div>見積り・図面を確認する</div>
            <div>注文</div>
            <div>発送</div>
          </div>
        </div>
        <div id="product_category">
          <div class="menu_title">商品カテゴリ一覧</div>
          <div v-if="!isHaseko">
            <ul class="ul_menu">
              <li v-for="(category,index) in categoryList" :key="'menu_category-' + index" @click="routeCategory(category.params)">{{category.title}}</li>
            </ul>
          </div>
          <div v-else>
            <ul class="ul_menu">
              <li v-for="(category,index) in categoryListHaseko" :key="'menu_category-' + index" @click="routeCategory(category.params)">{{category.title}}</li>
            </ul>
          </div>
        </div>
        <div id="series_list">
          <div class="menu_title">商品シリーズ一覧</div>
          <ul class="ul_menu">
            <li @click="route('DcSeriesPage')">パーソナルシェルフ</li>
          </ul>
        </div>
        <div id="main_menu">
          <div class="menu_title">メインメニュー</div>
          <ul class="ul_menu">
            <li v-if="isHaseko" @click="route('DcAbout2')">rashikuとは</li>
            <li v-else @click="route('DcAbout')">mm/styleとは</li>
            <li @click="routeCategory()">商品案内</li>
            <!-- <li @click="route('DcConstructModel')">施工事例</li> -->
            <!-- <li @click="route('')">お客様の声</li> -->
            <li @click="route('Faq')">よくある質問</li>
            <!-- <li @click="route('')">「サイズオーダー」への思い</li> -->
          </ul>
        </div>
        <div id="buy_">
          <div class="menu_title">ご購入に関して</div>
          <ul class="ul_menu">
            <li @click="route('DcPaymentGuide')">ご購入ガイド</li>
            <!-- <li @click="route('')">お支払い・送料について</li>
            <li @click="route('')">お届けについて</li>
            <li @click="route('')">領収書について</li> -->
            <li @click="route('DcTokutei')">特定商取引法の表示</li>
          </ul>
        </div>
        <div id="company">
          <div class="menu_title">私たちについて</div>
          <ul class="ul_menu">
            <li @click="route('DcCorpInformation')">会社案内</li>
            <!-- <li @click="route('')">スタッフ紹介</li> -->
            <li @click="route('UseRule')">利用規約</li>
            <li @click="route('SupportInput')">お問い合わせ</li>
          </ul>
        </div>
        <!-- <div id="calendar">
          <div class="menu_title">営業日カレンダー</div>
          <dd-calendar
            :schedule="schedule"
            :value="calDate"
            @selectedDate="selectedDate"
          />
        </div> -->
        <div id="sns">
          <div class="menu_title">SNS</div>
          <a href="https://www.instagram.com/mmstyle_domans/" target="_blank">
            <img :src="getImage('bunner/sns_instagram.webp')">
          </a>
          <a href="https://www.facebook.com/Mmstyle-%E3%83%9F%E3%83%AA%E3%82%B9%E3%82%BF%E3%82%A4%E3%83%AB-104010348490122" target="_blank">
            <img :src="getImage('bunner/sns_facebook.png')">
          </a>
        </div>
      </div>
      <div @click="close()">
        <div class="cross_btn">
          <span class="css-cancel"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as App from '../../../utils/App'
import {DC_STORAGE_KEY, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED, DC_PRPIC_ON} from '../../../constants/App'
import Calendar from '../../../components/common/Calendar'

export default {
  name: 'DcHeaderMenu',
  components: {
    'dd-calendar': Calendar
  },
  props: {
    isMenuActive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      categoryList: [
        {id: 1, title: '吊戸棚（フロート収納）', params: {cid: 1}},
        {id: 2, title: '食器棚（カップボード）', params: {cid: 2}},
        {id: 3, title: '玄関収納', params: {cid: 3}},
        {id: 4, title: 'カウンター', params: {cid: 4}},
        {id: 5, title: '棚板・フィラー', params: {cid: 5}},
        {id: 6, title: 'カウンター下収納', params: {cid: 6}},
        {id: 7, title: 'サイドボード', params: {cid: 7}},
        {id: 8, title: 'テレビボード', params: {cid: 8}},
        {id: 9, title: '本棚・デスク', params: {cid: 9}},
        {id: 14, title: 'クローゼット収納', params: {cid: 14}},
        {id: 15, title: '隙間収納', params: {cid: 15}},
        {id: 16, title: '可動間仕切収納', params: {cid: 16}},
        {id: 17, title: '洗面台', params: {cid: 17}},
        {id: 18, title: 'シェルフ', params: {cid: 18}},
        {id: 19, title: '単体キャビネット フロア', params: {cid: 19}},
        {id: 20, title: '単体キャビネット ウォール', params: {cid: 20}}
      ],
      categoryListHaseko: [
        {id: 1, title: '吊戸棚（フロート収納）', params: {cid: 1}},
        {id: 2, title: '食器棚（カップボード）', params: {cid: 2}},
        {id: 3, title: '玄関収納', params: {cid: 3}},
        {id: 4, title: 'カウンター', params: {cid: 4}},
        {id: 5, title: '棚板・フィラー', params: {cid: 5}},
        {id: 6, title: 'カウンター下収納', params: {cid: 6}},
        {id: 7, title: 'サイドボード', params: {cid: 7}},
        {id: 8, title: 'テレビボード', params: {cid: 8}},
        {id: 9, title: '本棚・デスク', params: {cid: 9}},
        {id: 14, title: 'クローゼット収納', params: {cid: 14}},
        {id: 15, title: '隙間収納', params: {cid: 15}},
        {id: 18, title: 'シェルフ', params: {cid: 18}},
        {id: 19, title: '単体キャビネット フロア', params: {cid: 19}},
        {id: 20, title: '単体キャビネット ウォール', params: {cid: 20}}
      ],
      schedule: {},
      calDate: '',
      user: {}
    }
  },
  computed: {
    isLogin: function () {
      if (!this.user || Object.keys(this.user).length <= 0) return false
      if (this.user.userId === undefined) return false
      if (this.user.userLevel === 4) return false
      return true
    },
    sketchOrderBunner: function () {
      var rcnt = Math.floor(Math.random() * 3)
      if (rcnt === 0) {
        return this.getImage('bunner/side_banner_SO01.png')
      } else if (rcnt === 1) {
        return this.getImage('bunner/side_banner_SO02.png')
      } else {
        return this.getImage('bunner/side_banner_SO03.png')
      }
    },
    isSketchOrder: function () {
      if (process.env.SKETCH_ORDER !== 1) {
        return false
      }
      return true
    },
    isHaseko: function () {
      return (this.user && this.user.corpId >= STRUCT_CORP_ID_ST && this.user.corpId <= STRUCT_CORP_ID_ED)
    }
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    route: function (name, params) {
      this.$router.push({
        name: name,
        query: params
      })
    },
    routeCategory: function (params) {
      App.removeLocalStorage(DC_STORAGE_KEY.PRODUCT_SEARCH)
      if (DC_PRPIC_ON === 1) {
        this.$router.push({
          name: 'DcPrpic',
          query: params
        })
      } else {
        this.$router.push({
          name: 'DcCategory',
          query: params
        })
      }
    },
    // scheduling: function () {
    //   axios.get(DC_URL.SCHEDULE + '/business')
    //     .then(response => {
    //       this.schedule = response.data.data
    //     }).catch(error => {
    //       this.validateErrorMessages = {}
    //       Api.handleError(error, this.errorMessage, this.validateErrorMessages)
    //       this.$router.push('/mmstyle/error')
    //       this.$refs.loadingModalRef.showModal(false)
    //     })
    // },
    selectedDate: function (selectedDate) {
      let format = 'YYYY-MM-dd'.replace(/YYYY/g, selectedDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (selectedDate.getMonth() + 1)).slice(-2))
      format = format.replace(/dd/g, ('0' + selectedDate.getDate()).slice(-2))
      this.calDate = format
    },
    close: function () {
      this.$emit('close')
    }
  },
  mounted () {
    // this.scheduling()
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../../css/dcmenu.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/top/DcLeftMenu.vue